// No Hook, just a UI component Loader
import Loader from "react-loader-spinner";
import {useState} from "react";

const styles = {
    container: {
        height: "50vh",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
    },
    text: {
        textAlign: 'center',
        marginTop: '20px',
        color: '#3f51b5'
    }
};

const useLoader = (type, color, vh,vw) => {
    const [load, setLoad] = useState(false);

    const loaderComponent = (
            <div style={styles.container}>
                <Loader
                     type={type?type:'Watch'}
                     color={color?color:"#3f51b5"}
                     height={vh?vh:80}
                     width={vw?vw:80}
                />
                <h2 style={styles.text}>
                    CARGANDO DATOS
                </h2>
            </div>
    );
    return {
        load: load,
        setLoad: setLoad,
        loaderComponent: loaderComponent
    }
};


export default useLoader;
// const loaderComponent =
//     (
//         <div style={{height:"50vh", display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
//             <Loader type="Watch" color="#3f51b5" height={80} width={80} />
//             <h2 style={{textAlign:'center', marginTop:'20px', color:'#3f51b5'}}> CARGANDO DATOS</h2>
//         </div>
//     )
//
// export default loaderComponent;